import React from 'react'
import useSearch from '../../../context/search/useSearch';

interface ISearchInputComponent {
  dataSet: DOMStringMap
}

const SearchSubmit: React.FC<ISearchInputComponent> = ({dataSet}): JSX.Element => {

  const { submitText } = dataSet

  const {quickSearchTerm,quickSearchResultsProducts } = useSearch()

  if (!quickSearchTerm || !quickSearchResultsProducts || quickSearchResultsProducts.length < 1) {
    return null
  }

  return (
    <React.Fragment>
      {/* Canonical search URL: lower-cased term + type=product — see useSearch.tsx */}
      <a className="btn btn--primary" href={`/search?q=${quickSearchTerm.toLowerCase().replace(/ /g, '+')}&type=product`}>{ submitText.replace(/\[\[terms\]\]/g, quickSearchTerm) }</a>
    </React.Fragment>
  )
};

export default SearchSubmit